import React, { useEffect } from 'react';
import { Link, navigate } from 'gatsby';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import Layout from '@components/layout';

const StyledPensieveContainer = styled.main`
  max-width: 1000px;
`;

const PensievePage = ({ location }) => {
  useEffect(() => {
    navigate('/blog', { replace: true });
  }, []);

  return (
    <Layout location={location}>
      <Helmet title="Pensieve" />

      <StyledPensieveContainer>
        <h1 className="big-heading">Pensieve</h1>
        <p>Redirecting to the blog index...</p>
        <p>
          If you are not redirected, <Link to="/blog">open the blog index</Link>.
        </p>
      </StyledPensieveContainer>
    </Layout>
  );
};

PensievePage.propTypes = {
  location: PropTypes.object,
};

export default PensievePage;

